module.exports = __webpack_public_path__ + "img/logo.07b4826a.svg";